import { AboutScreen } from 'app/features/legal/about-screen'
import { HomeLayout } from 'components/home/HomeLayout'
import { NextSeo } from 'next-seo'

import { NextPageWithLayout } from './_app'

export const Page: NextPageWithLayout = () => {
  return (
    <>
      <NextSeo title="About Us" />
      <AboutScreen showVideo={false} />
    </>
  )
}

Page.getLayout = (page) => <HomeLayout>{page}</HomeLayout>

export default Page
